export default "__VITE_ASSET__CFm6zAYv__"